<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>User Level</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Tambah User Level
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="id_narasumber">Narasumber</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <select id="id_narasumber" class="form-control" v-model="idNarasumber">
                                                <option value="">[ Pilih Narasumber ]</option>
                                                <option v-for="option in list_narasumber" v-bind:value="option.idNarasumber">
                                                    {{ option.nama }} ({{ option.singkatan }})
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="namaLengkap">Nama Lengkap</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line type="text" id="namaLengkap" placeholder="Masukkan Nama Lengkap" v-model="namaLengkap"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="email">Email</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line type="email" id="email" placeholder="Masukkan Email" v-model="email"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="username">Username</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line type="text" id="username" placeholder="Masukkan Username" v-model="username"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="password">Password</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line type="password" id="password" placeholder="Masukkan Password (Alfanumerik a-z A-Z 0-9)" v-model="password"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="username">Akses Menu</label>
                                    </div>
                                    <div class="col-lg-10">
                                        <div class="col-lg-6">
                                            <div class="panel-group"role="tablist" aria-multiselectable="true">
                                                <div class="panel-group" id="accordion_1" role="tablist" aria-multiselectable="true">
                                                    <div class="panel">
                                                        <div class="panel-heading" role="tab">
                                                            <h4 class="panel-title">
                                                                <a role="button">
                                                                    Profile
                                                                    <div class="pull-right">
                                                                        <input type="checkbox" id="profile" class="filled-in" v-model="profileAll" value="1">
                                                                        <label for="profile"></label>
                                                                    </div>
                                                                </a>
                                                            </h4>
                                                        </div>
                                                        <div id="collapseOne_1" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne_1">
                                                            <div class="panel-body">
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="visi_misi" class="filled-in" v-model="akses.profile.visi_misi" value="1">
                                                                    <label for="visi_misi">Visi Misi</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="sejarah_pendirian" class="filled-in" v-model="akses.profile.sejarah_pendirian" value="1">
                                                                    <label for="sejarah_pendirian">Sejarah Pendirian</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="pendiri" class="filled-in" v-model="akses.profile.pendiri" value="1">
                                                                    <label for="pendiri">Pendiri</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="dewan_pengawas" class="filled-in" v-model="akses.profile.dewan_pengawas" value="1">
                                                                    <label for="dewan_pengawas">Dewan Pengawas</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="pengurus" class="filled-in" v-model="akses.profile.pengurus" value="1">
                                                                    <label for="pengurus">Pengurus</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="struktur_organisasi" class="filled-in" v-model="akses.profile.struktur_organisasi" value="1">
                                                                    <label for="struktur_organisasi">Struktur Organisasi</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="budaya_kerja" class="filled-in" v-model="akses.profile.budaya_kerja" value="1">
                                                                    <label for="budaya_kerja">Budaya Kerja</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="panel">
                                                        <div class="panel-heading" role="tab" id="headingOne_1">
                                                            <h4 class="panel-title">
                                                                <a role="button" data-toggle="collapse">
                                                                    Layanan
                                                                    <div class="pull-right">
                                                                        <input type="checkbox" id="layanan" class="filled-in" v-model="layananAll" value="1">
                                                                        <label for="layanan"></label>
                                                                    </div>
                                                                </a>
                                                            </h4>
                                                        </div>
                                                        <div class="panel-collapse collapse in">
                                                            <div class="panel-body">
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="cetak-mp" class="filled-in" v-model="akses.layanan.cetak_mp" value="1">
                                                                    <label for="cetak-mp">Cetak StrukMP/Pph21</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="cetak-up" class="filled-in" v-model="akses.layanan.cetak_up" value="1">
                                                                    <label for="cetak-up">Cetak Struk Uang Pembinaan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="cetak-rapel" class="filled-in" v-model="akses.layanan.cetak_rapel" value="1">
                                                                    <label for="cetak-rapel">Cetak Struk Rapel Kenaikan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="cetak-spt" class="filled-in" v-model="akses.layanan.cetak_spt" value="1">
                                                                    <label for="cetak-spt">Cetak SPT</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="identitas-pemotong" class="filled-in" v-model="akses.layanan.atur_ip" value="1">
                                                                    <label for="identitas-pemotong">Atur Identitas Pemotong</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="survey" class="filled-in" v-model="akses.layanan.survey" value="1">
                                                                    <label for="survey">Survey Pelayanan Pensiun</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="hasil-survey" class="filled-in" v-model="akses.layanan.hasil_survey" value="1">
                                                                    <label for="hasil-survey">Hasil Survey Pelayanan Pensiun</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="data-kelengkapan" class="filled-in" v-model="akses.layanan.data_kelengkapan" value="1">
                                                                    <label for="data-kelengkapan">Data Kelengkapan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="data-kelengkapan" class="filled-in" v-model="akses.layanan.pengaduan" value="1">
                                                                    <label for="data-kelengkapan">Pengaduan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="data-kelengkapan" class="filled-in" v-model="akses.layanan.kritik" value="1">
                                                                    <label for="data-kelengkapan">Kritik</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="panel">
                                                        <div class="panel-heading" role="tab">
                                                            <h4 class="panel-title">
                                                                <a role="button">
                                                                    Informasi
                                                                    <div class="pull-right">
                                                                        <input type="checkbox" id="informasi" class="filled-in" v-model="informasiAll" value="1">
                                                                        <label for="informasi"></label>
                                                                    </div>
                                                                </a>
                                                            </h4>
                                                        </div>
                                                        <div class="panel-collapse collapse in">
                                                            <div class="panel-body">
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="kegiatan" class="filled-in" v-model="akses.informasi.kegiatan" value="1">
                                                                    <label for="kegiatan">Kegiatan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="Artikel" class="filled-in" v-model="akses.informasi.artikel" value="1">
                                                                    <label for="Artikel">Artikel</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="perkembangan" class="filled-in" v-model="akses.informasi.perkembangan" value="1">
                                                                    <label for="perkembangan">Perkembangan Investasi Semesteran</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="tahunan" class="filled-in" v-model="akses.informasi.tahunan" value="1">
                                                                    <label for="tahunan">Laporan Keuangan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="lowongan" class="filled-in" v-model="akses.informasi.lowongan" value="1">
                                                                    <label for="lowongan">Lowongan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="galeri" class="filled-in" v-model="akses.informasi.galeri" value="1">
                                                                    <label for="galeri">Galeri</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="panel">
                                                        <div class="panel-heading" role="tab">
                                                            <h4 class="panel-title">
                                                                <a role="button">
                                                                    Unduh
                                                                    <div class="pull-right">
                                                                        <input type="checkbox" id="unduh" class="filled-in" v-model="unduhAll" value="1">
                                                                        <label for="unduh"></label>
                                                                    </div>
                                                                </a>
                                                            </h4>
                                                        </div>
                                                        <div class="panel-collapse collapse in">
                                                            <div class="panel-body">
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="pdp" class="filled-in" v-model="akses.unduh.pdp" value="1">
                                                                    <label for="pdp">PDP</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="arahan" class="filled-in" v-model="akses.unduh.arahan" value="1">
                                                                    <label for="arahan">Arahan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="regulasi" class="filled-in" v-model="akses.unduh.regulasi" value="1">
                                                                    <label for="regulasi">Regulasi Dana Pensiun</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="majalah" class="filled-in" v-model="akses.unduh.majalah" value="1">
                                                                    <label for="majalah">Majalah DAPENBI</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="materikomunikasi" class="filled-in" v-model="akses.unduh.materikomunikasi" value="1">
                                                                    <label for="materikomunikasi">Materi Komunikasi</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="laporan" class="filled-in" v-model="akses.unduh.laporan" value="1">
                                                                    <label for="laporan">Laporan</label>
                                                                </div>
                                                                <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                                                    <input type="checkbox" id="formulir" class="filled-in" v-model="akses.unduh.formulir" value="1">
                                                                    <label for="formulir">Formulir</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Master Narasumber
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="masterNarasumber" class="filled-in" v-model="akses.masterNarasumber" value="1">
                                                                <label for="masterNarasumber"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            User Level
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="userLevel" class="filled-in" v-model="akses.userLevel" value="1">
                                                                <label for="userLevel"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Data Anggota
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="anggota" class="filled-in" v-model="akses.anggota" value="1">
                                                                <label for="anggota"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Log
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="log" class="filled-in" v-model="akses.log" value="1">
                                                                <label for="log"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            FAQ
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="faq" class="filled-in" v-model="akses.faq" value="1">
                                                                <label for="faq"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Syarat Kepesertaan
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="syarat" class="filled-in" v-model="akses.syarat" value="1">
                                                                <label for="syarat"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Cara Mendaftar
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="cara" class="filled-in" v-model="akses.cara" value="1">
                                                                <label for="cara"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Slider
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="slider" class="filled-in" v-model="akses.slider" value="1">
                                                                <label for="slider"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Kirim Notifikasi
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="kirimNotifikasi" class="filled-in" v-model="akses.kirimNotifikasi" value="1">
                                                                <label for="kirimNotifikasi"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Headline
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="headline" class="filled-in" v-model="akses.headline" value="1">
                                                                <label for="headline"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            WhistleBlower
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="whistleBlower" class="filled-in" v-model="akses.whistleBlower" value="1">
                                                                <label for="whistleBlower"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Anak Perusahaan
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="anakPerusahaan" class="filled-in" v-model="akses.anakPerusahaan" value="1">
                                                                <label for="anakPerusahaan"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Pengumuman
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="Pengumuman" class="filled-in" v-model="akses.Pengumuman" value="1">
                                                                <label for="Pengumuman"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Kalender
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="Kalender" class="filled-in" v-model="akses.Kalender" value="1">
                                                                <label for="Kalender"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Hak dan Kewajiabn Peserta
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="hakDanKewajibanPeserta" class="filled-in" v-model="akses.Hak_dan_Kewajiban_Peserta"/>
                                                                <label for="hakDanKewajibanPeserta"></label>
                                                                <label for="Hak_dan_Kewajiban_Peserta"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Banner
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="Banner" class="filled-in" v-model="akses.Banner" value="1">
                                                                <label for="Banner"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-heading" role="tab">
                                                    <h4 class="panel-title">
                                                        <a role="button">
                                                            Hubungi Kami
                                                            <div class="pull-right">
                                                                <input type="checkbox" id="hubungiKami" class="filled-in" v-model="akses.hubungiKami" value="1">
                                                                <label for="hubungiKami"></label>
                                                            </div>
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" v-if="id_user != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Edit</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button v-bind:disabled="isLoading" v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Simpan</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine},
    name: 'FormAdmin',
    watch: {
      profileAll: function (val) {
        if (val === true) {
          Object.entries(this.akses.profile).forEach(
            ([key, value]) => { this.akses.profile[key] = true }
          )
        } else {
          Object.entries(this.akses.profile).forEach(
            ([key, value]) => { this.akses.profile[key] = false }
          )
        }
      },
      layananAll: function (val) {
        if (val === true) {
          Object.entries(this.akses.layanan).forEach(
            ([key, value]) => { this.akses.layanan[key] = true }
          )
        } else {
          Object.entries(this.akses.layanan).forEach(
            ([key, value]) => { this.akses.layanan[key] = false }
          )
        }
      },
      informasiAll: function (val) {
        if (val === true) {
          Object.entries(this.akses.informasi).forEach(
            ([key, value]) => { this.akses.informasi[key] = true }
          )
        } else {
          Object.entries(this.akses.informasi).forEach(
            ([key, value]) => { this.akses.informasi[key] = false }
          )
        }
      },
      unduhAll: function (val) {
        if (val === true) {
          Object.entries(this.akses.unduh).forEach(
            ([key, value]) => { this.akses.unduh[key] = true }
          )
        } else {
          Object.entries(this.akses.unduh).forEach(
            ([key, value]) => { this.akses.unduh[key] = false }
          )
        }
      }
    },
    data: function () {
      return {
        username: '',
        password: '',
        email: '',
        namaLengkap: '',
        profileAll: false,
        layananAll: false,
        informasiAll: false,
        unduhAll: false,
        idNarasumber: '',
        akses: {
          masterNarasumber: false,
          userLevel: false,
          anggota: false,
          profile: {
            visi_misi: false,
            sejarah_pendirian: false,
            pendiri: false,
            dewan_pengawas: false,
            pengurus: false,
            struktur_organisasi: false,
            budaya_kerja: false
          },
          layanan: {
            cetak_mp: false,
            cetak_up: false,
            cetak_rapel: false,
            cetak_spt: false,
            atur_ip: false,
            survey: false,
            hasil_survey: false,
            data_kelengkapan: false,
            pengaduan: false,
            kritik: false
          },
          informasi: {
            kegiatan: false,
            artikel: false,
            perkembangan: false,
            tahunan: false,
            lowongan: false,
            galeri: false
          },
          unduh: {
            pdp: false,
            arahan: false,
            regulasi: false,
            majalah: false,
            laporan: false,
            formulir: false,
            materikomunikasi: false
          },
          log: false,
          faq: false,
          syarat: false,
          cara: false,
          slider: false,
          kirimNotifikasi: false,
          headline: false,
          whistleBlower: false,
          anakPerusahaan: false,
          hubungiKami: false,
          Kalender: false,
          Banner: false,
          Pengumuman: false,
          Hak_dan_Kewajiban_Peserta: false
        },
        id_user: '',
        isLoading: false,
        list_narasumber: []
      }
    },
    methods: {
      getData () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/narasumber/all').then((result) => {
          this.list_narasumber = result.data
        })
      },
      save () {
        this.isLoading = true

        const data = {
          id_narasumber: this.idNarasumber,
          namaLengkap: this.namaLengkap,
          username: this.username,
          password: this.password,
          email: this.email,
          akses_menu: JSON.stringify(this.akses)
        }

        let pattern = /^[a-zA-Z0-9]*$/
        if (!this.password.match(pattern)) {
          this.$toastr.e('Password tidak valid, hanya boleh alfanumerik (a-z atau A-Z dan 0-9)')
          this.isLoading = false
          return false
        }

        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/admin', data).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/admin')
            this.$toastr.s('Tambah data berhasil')
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      update () {
        const data = {
          id_narasumber: this.idNarasumber,
          namaLengkap: this.namaLengkap,
          username: this.username,
          password: this.password,
          email: this.email,
          akses_menu: JSON.stringify(this.akses)
        }

        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/admin/' + this.id_user, data).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/admin')
            this.$toastr.s('Ubah data berhasil')
          }
        }).catch((e) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      getDetail () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/admin/' + this.id_user).then((result) => {
          const data = result.data
          this.username = data.registrasi.username
          this.email = data.registrasi.email
          this.namaLengkap = data.namaLengkap
          this.akses = JSON.parse(data.akses_menu)
          this.idNarasumber = JSON.parse(data.narasumber.idNarasumber)
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      handleFile (file) {
        this.file = file.target.files[0]
      }
    },
    mounted () {
      this.getData()
      this.id_user = this.$route.params.id
      if (this.id_user != null) {
        this.getDetail()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Admin/FormAdmin.vue?58809b70